// extracted by mini-css-extract-plugin
module.exports = {"label":"styles-module__label___3olu7","label_remix_icon":"styles-module__label_remix_icon___7H5zc"};